import { render, staticRenderFns } from "./RiskOrgnManage_20220509.vue?vue&type=template&id=c198a8ae&scoped=true&"
import script from "./RiskOrgnManage_20220509.vue?vue&type=script&lang=js&"
export * from "./RiskOrgnManage_20220509.vue?vue&type=script&lang=js&"
import style0 from "./RiskOrgnManage_20220509.vue?vue&type=style&index=0&id=c198a8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c198a8ae",
  null
  
)

export default component.exports